import {ActionIcon} from '@mantine/core';

export const ActionIconTheme = ActionIcon.extend({
  defaultProps: {
    variant: 'subtle',
  }
});